import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { Home, Landmark, HandHeart, Calendar, BedDouble, Languages, Flame, Phone, X } from "lucide-react";
import { useLang } from "../../i18n/LanguageContext";

const BottomNav = () => {
  const [fabOpen, setFabOpen] = useState(false);
  const { lang, setLang } = useLang();

  const items = [
    { to: "/", icon: Home, label: "Home", testid: "bnav-home" },
    { to: "/deities", icon: Landmark, label: "Deities", testid: "bnav-darshana" },
    { to: "/sevas", icon: HandHeart, label: "Seva", testid: "bnav-seva" },
    { to: "/events", icon: Calendar, label: "Events", testid: "bnav-events" },
    { to: "/rooms", icon: BedDouble, label: "Rooms", testid: "bnav-more" },
  ];

  return (
    <>
      {/* Floating action button - temple lamp */}
      <div className="lg:hidden fixed bottom-24 right-4 z-40" data-testid="fab-container">
        {fabOpen && (
          <div className="absolute bottom-16 right-0 flex flex-col gap-3 mb-2">
            {[
              { icon: Languages, label: lang === "kn" ? "English" : "ಕನ್ನಡ", type: "language", testid: "fab-language" },
              { icon: HandHeart, label: "Donate", to: "/sevas", testid: "fab-donate" },
              { icon: Calendar, label: "Book Seva", to: "/sevas", testid: "fab-book" },
              { icon: Phone, label: "Contact", to: "/contact", testid: "fab-contact" },
            ].map((f) => {
              if (f.type === "language") {
                return (
                  <button
                    key={f.label}
                    type="button"
                    onClick={() => {
                      setLang(lang === "en" ? "kn" : "en");
                      setFabOpen(false);
                    }}
                    className="flex items-center gap-3 justify-end"
                    data-testid={f.testid}
                    aria-label="Switch language"
                    aria-pressed={lang === "kn"}
                  >
                    <span className="bg-[#3B2A1A] text-[#FBF7F0] text-xs px-3 py-1.5 rounded-full font-medium whitespace-nowrap shadow-lg">
                      {f.label}
                    </span>
                    <span className="w-11 h-11 rounded-full bg-[#FBF7F0] border border-[#D4AF37] text-[#B65A14] flex items-center justify-center shadow-md">
                      <f.icon className="w-5 h-5" />
                    </span>
                  </button>
                );
              }

              return (
                <NavLink
                  key={f.label}
                  to={f.to}
                  onClick={() => setFabOpen(false)}
                  className="flex items-center gap-3 justify-end"
                  data-testid={f.testid}
                >
                  <span className="bg-[#3B2A1A] text-[#FBF7F0] text-xs px-3 py-1.5 rounded-full font-medium whitespace-nowrap shadow-lg">
                    {f.label}
                  </span>
                  <span className="w-11 h-11 rounded-full bg-[#FBF7F0] border border-[#D4AF37] text-[#B65A14] flex items-center justify-center shadow-md">
                    <f.icon className="w-5 h-5" />
                  </span>
                </NavLink>
              );
            })}
          </div>
        )}
        <button
          onClick={() => setFabOpen(!fabOpen)}
          className="w-14 h-14 rounded-full bg-gradient-to-br from-[#D4AF37] to-[#B65A14] text-[#3B2A1A] flex items-center justify-center shadow-2xl animate-lamp-glow"
          data-testid="fab-toggle"
          aria-label="Quick actions"
        >
          {fabOpen ? <X className="w-6 h-6" /> : <Flame className="w-6 h-6" />}
        </button>
      </div>

      {/* Bottom Nav (mobile only) */}
      <nav
        className="lg:hidden fixed bottom-0 inset-x-0 z-40 backdrop-blur-xl bg-[#FBF7F0]/95 border-t border-[#D4AF37]/30"
        data-testid="bottom-nav"
      >
        <div className="grid grid-cols-5">
          {items.map((it) => (
              <NavLink
                key={it.to}
                to={it.to}
                className={({ isActive }) =>
                  `flex flex-col items-center justify-center py-3 gap-1 text-[10px] tracking-wider uppercase ${isActive ? "text-[#B65A14]" : "text-[#3B2A1A]/70"}`
                }
                data-testid={it.testid}
                end={it.to === "/"}
              >
                {({ isActive }) => (
                  <>
                    <it.icon className={`w-5 h-5 ${isActive ? "text-[#D4AF37]" : ""}`} />
                    <span className="font-medium">{it.label}</span>
                  </>
                )}
              </NavLink>
          ))}
        </div>
      </nav>
    </>
  );
};

export default BottomNav;
